import {
  CheckCircle2,
  DollarSign,
  Link,
  MessageCircle,
  Package,
  PlayCircle,
  Trophy,
  Zap,
  BarChart3,
  FileText,
  Search,
} from 'lucide-react';

// Dashboard Quick Actions
export const quickActions = [
  {
    label: 'New Order',
    icon: Package,
    color: '#4F46E5',
  },
  {
    label: 'Browse Sites',
    icon: Search,
    color: '#059669',
  },
  {
    label: 'Add Content',
    icon: FileText,
    color: '#D97706',
  },
  {
    label: 'View Analytics',
    icon: BarChart3,
    color: '#DC2626',
  },
];

// Dashboard KPI Data
export const kpiData = [
  {
    id: 'backlinks',
    title: 'Total Backlinks',
    value: '2,847',
    change: '+12%',
    changeType: 'positive' as const,
    trend: 'up',
    description: 'vs last month',
    icon: Link,
    color: '#4F46E5',
    bg: 'rgba(79, 70, 229, 0.15)',
    iconBg: '#E8E6FF',
  },
  {
    id: 'domain-authority',
    title: 'Domain Authority',
    value: '67',
    change: '+3 pts',
    changeType: 'positive' as const,
    trend: 'up',
    description: 'vs last month',
    icon: Trophy,
    color: '#059669',
    bg: 'rgba(5, 150, 105, 0.15)',
    iconBg: '#E2F7F2',
  },
  {
    id: 'active-orders',
    title: 'Active Orders',
    value: '12',
    change: '+2',
    changeType: 'positive' as const,
    trend: 'up',
    description: 'vs last month',
    icon: Package,
    color: '#3B82F6',
    bg: 'rgba(59, 130, 246, 0.15)',
    iconBg: '#DCEBFA',
  },
  {
    id: 'wallet-balance',
    title: 'Wallet Balance',
    value: '$1,234',
    change: '-$156',
    changeType: 'negative' as const,
    trend: 'down',
    description: 'vs last month',
    icon: Zap,
    color: '#10B981',
    bg: 'rgba(16, 185, 129, 0.15)',
    iconBg: '#E6F4EC',
  },
];

// Dashboard Chart Data
export const chartDataByPeriod = {
  '7d': [
    { month: 'Mon', backlinks: 2720, authority: 67 },
    { month: 'Tue', backlinks: 2735, authority: 67 },
    { month: 'Wed', backlinks: 2765, authority: 67 },
    { month: 'Thu', backlinks: 2780, authority: 68 },
    { month: 'Fri', backlinks: 2810, authority: 68 },
    { month: 'Sat', backlinks: 2825, authority: 68 },
    { month: 'Sun', backlinks: 2847, authority: 68 },
  ],
  '30d': [
    { month: 'Week 1', backlinks: 2580, authority: 67 },
    { month: 'Week 2', backlinks: 2650, authority: 67 },
    { month: 'Week 3', backlinks: 2720, authority: 68 },
    { month: 'Week 4', backlinks: 2847, authority: 68 },
  ],
  '90d': [
    { month: 'Jan', backlinks: 2100, authority: 65 },
    { month: 'Feb', backlinks: 2250, authority: 66 },
    { month: 'Mar', backlinks: 2400, authority: 67 },
    { month: 'Apr', backlinks: 2580, authority: 68 },
    { month: 'May', backlinks: 2750, authority: 68 },
    { month: 'Jun', backlinks: 2847, authority: 68 },
  ],
  '1y': [
    { month: 'Q1 2024', backlinks: 1850, authority: 62 },
    { month: 'Q2 2024', backlinks: 2100, authority: 64 },
    { month: 'Q3 2024', backlinks: 2380, authority: 66 },
    { month: 'Q4 2024', backlinks: 2640, authority: 67 },
    { month: 'Q1 2025', backlinks: 2847, authority: 68 },
  ],
};

// Order Status Data
export const orderStatusData = [
  {
    name: 'Completed',
    value: 65,
    count: 45,
    color: '#27AE60',
    bg: '#E6F4EC',
  },
  {
    name: 'In Progress',
    value: 26,
    count: 18,
    color: '#F59E0B',
    bg: '#FFF9E6',
  },
  {
    name: 'Pending',
    value: 9,
    count: 6,
    color: '#568EF5',
    bg: '#E3F2FD',
  },
];

// Activity Data
export const activityData = [
  {
    id: '1',
    title: 'Guest Post Order Completed',
    description: 'Your guest post on TechCrunch.com is now live',
    time: '2 hours ago',
    status: 'success',
    icon: CheckCircle2,
    bg: '#FFFFFF',
  },
  {
    id: '2',
    title: 'Payment Received',
    description: '$599 credited to your wallet',
    time: '4 hours ago',
    status: 'info',
    icon: DollarSign,
    bg: '#FFFFFF',
  },
  {
    id: '3',
    title: 'New Order Started',
    description: 'SEO Audit for example.com has begun',
    time: '1 day ago',
    status: 'warning',
    icon: PlayCircle,
    bg: '#FFFFFF',
  },
  {
    id: '4',
    title: 'Message from Support',
    description: 'Your support ticket has been resolved',
    time: '2 days ago',
    status: 'info',
    icon: MessageCircle,
    bg: '#FFFFFF',
  },
];

// Top Sources Data
export const topSourcesData = [
  {
    name: 'TechCrunch',
    value: 342,
    percentage: 28,
    color: '#4F46E5',
    bg: '#E8E6FF',
  },
  {
    name: 'Forbes',
    value: 287,
    percentage: 24,
    color: '#059669',
    bg: '#E2F7F2',
  },
  {
    name: 'Entrepreneur',
    value: 198,
    percentage: 16,
    color: '#F59E0B',
    bg: '#FFF9E6',
  },
  {
    name: 'Medium',
    value: 156,
    percentage: 13,
    color: '#8B5CF6',
    bg: '#EDE9FE',
  },
  {
    name: 'Others',
    value: 234,
    percentage: 19,
    color: '#10B981',
    bg: '#E6F4EC',
  },
];
